module.exports = __webpack_public_path__ + "static/pi5-088d52de18dd5a9d92776c59d3c2b187.png";